import React from 'react';
import styled from 'styled-components';
import { ItemProperty } from './CommonStyles';

interface ICartItemSize {
  productSize: string;
  sizeLabel: string;
}

const CartItemSizeWrapper = styled(ItemProperty)`
  font-size: 12px;
  margin-bottom: 4px;
`;

const CartItemSize = ({ productSize, sizeLabel }: ICartItemSize): JSX.Element => (
  <CartItemSizeWrapper
    className="cart-item-child cart-item-size"
    data-test-id="dp_product_size"
  >
    {sizeLabel}:&nbsp;{productSize}
  </CartItemSizeWrapper>
);

export default CartItemSize;
